// removed by extract-text-webpack-plugin
module.exports = {"userPic":"style__userPic___oy-Gw","userName":"style__userName___aLdtK","menuDropdown":"style__menuDropdown___2R9hX","menuMobile":"style__menuMobile___1r87_","logo":"style__logo___2tzdG","hasNew":"style__hasNew___2v5wM"};


//////////////////
// WEBPACK FOOTER
// ./components/Menu/style.scss
// module id = ./components/Menu/style.scss
// module chunks = 5